import { REALTOR_FORM_LINK_TO_CATALOG } from '../../constants/experiments';
import { TAbUseExperimentsState } from '../../types/abUseExperiments/abUseExperiments';

export const isCatalogLinkEnabled = (abUseExperiments: TAbUseExperimentsState = []) => {
  const experiment = abUseExperiments.find(({ experimentName }) => experimentName === REALTOR_FORM_LINK_TO_CATALOG);

  return experiment?.groupName === 'enabled';
};
